const ERROR_MESSAGES = {
  HRIS_INTEGRATION_INITIATION_FAILED:
    'Unable to initiate the HRIS integration. Try again later or contact support@kula.ai for help.',
  HRIS_CANDIDATE_ADD_FAILED:
    'Unable to add the candidate to the HRIS. Try again later or contact support@kula.ai for help.',
  INVALID_SSO_PROVIDER: 'Invalid SSO. Try logging in via another SSO provider',
};

const integrations = {
  // Workday position creation (kombo/workday passthrough). The other code these
  // endpoints answer with, err_kombo_api_failed, is already listed below and
  // shared with the rest of the HRIS flows. The vendor's own `details` /
  // `error_detail` text wins over the static copy whenever it is present.
  err_workday_position_missing: {
    message:
      'Create the Workday position for this candidate first — the hire needs one to hire into.',
  },
  err_workday_validation: {
    message:
      'Workday rejected the position details. Check the fields and try again.',
  },
  err_missing_tokens_from_rippling: {
    message: 'Missing tokens from Rippling.',
  },
  err_rippling_callback_failed: {
    message: 'Rippling callback failed.',
  },
  err_global_integration_not_found: {
    message: 'Global integration not found.',
  },
  err_token_required: {
    message:
      ' Authentication token has expired. Try authenticating Rippling again.',
  },
  err_invalid_cache_key: {
    message: 'Invalid cache key.',
  },
  err_oauth_session_expired: {
    message: 'Your session has expired. Try authenticating Rippling again.',
  },
  err_auth_code_required: {
    message: 'Auth code required.',
  },
  err_token_expired: {
    message: 'Token expired.',
  },
  err_token_invalid: {
    message: 'Token invalid.',
  },
  err_accounts_not_found: {
    message: 'Account not found.',
  },
  err_integration_type_not_found: {
    message: 'Integration type not found.',
  },
  err_email_missing: {
    message: 'Email missing.',
  },
  err_code_missing: {
    message: ' Authentication Code missing.',
  },
  err_redirect_uri_missing: {
    message: 'Redirect URI missing.',
  },
  err_email_too_long: {
    message: 'Email too long.',
  },
  err_unknown_integration_type: {
    message: 'Unknown integration type.',
  },
  err_candidate_already_pushed_to_hris: {
    message: 'This candidate has been added to Rippling already',
  },
  err_missing_integration_type: {
    message: 'Missing integration type.',
  },
  err_sso_not_enabled: {
    message: ' Invalid SSO. Try logging in via another SSO provider',
  },
  err_sso_url_not_found: {
    message:
      'Unable to log in via SSO. Contact your Kula admin to verify the SSO configuration.',
  },
  err_account_url_not_present: {
    message: 'Account URL not present.',
  },
  err_invalid_account_url: {
    message: 'Invalid account URL.',
  },
  err_api_key_not_present: {
    message: 'API key not present.',
  },
  err_invalid_credentials: {
    message: 'Invalid account URL or API key. Verify them and try again.',
  },
  err_integration_type_not_present: {
    message: 'Integration type not present.',
  },
  err_invalid_integration_type: {
    message: 'Invalid integration type.',
  },
  err_integration_not_found: {
    message: 'Integration already disconnected.', //common error message if you try to disconnect an already disconnected integration
  },
  err_certn_integration_not_found: {
    message:
      'Certn integration is not connected. Please enable it in Settings.',
  },
  err_unsupported_integration: {
    message: 'Unsupported integration type.',
  },
  err_authentication_failed: {
    message:
      'Authentication failed. Please check your credentials and try again.',
  },
  err_unexpected_error: {
    message: 'An unexpected error occurred. Please try again.',
  },
  err_cannot_disable: {
    message: 'Atleast one SSO should be enabled',
  },
  err_invalid_certificate: {
    message: ' Incorrect X.509 certificate. Verify it and try again.',
  },
  err_missing_name: {
    message: 'Please provide a name for the SSO configuration.',
  },
  err_invalid_metadata: {
    message: 'The provided metadata is invalid. Please check and try again.',
  },
  err_invalid_file_type: {
    message: 'Invalid file type. Please upload an XML file.',
  },
  err_invalid_url: {
    message: 'The provided URL is invalid. Please enter a valid URL.',
  },
  err_metadata_fetch_failed: {
    message: 'Incorrect metadata URL. Verify it and try again.',
  },
  err_missing_saml_data: {
    message:
      'Required SAML data is missing. Please provide all required information.',
  },
  err_invalid_entity_id: {
    message: 'The Entity ID is invalid. Please check and try again.',
  },
  err_invalid_sso_url: {
    message: 'Incorrect SSO URL. Verify it and try again.',
  },
  err_sso_provider_already_exists: {
    message:
      'SSO has already been configured for this provider. Try updating the existing configuration.',
  },
  err_invalid_auth_option: {
    message: 'Invalid authentication option',
  },
  err_sso_provider_not_found: {
    message: ERROR_MESSAGES.INVALID_SSO_PROVIDER,
  },
  err_tool_id_not_present: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_integration_category_not_present: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_integration_category_not_found: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_connection_link_not_created: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_reconnection_link_not_created: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_employee_form_not_found: {
    message: ERROR_MESSAGES.HRIS_INTEGRATION_INITIATION_FAILED,
  },
  err_employee_form_response_not_present: {
    message: 'HRIS form is empty. Fill the form out before trying again.',
  },
  err_application_id_not_present: {
    message: ERROR_MESSAGES.HRIS_CANDIDATE_ADD_FAILED,
  },
  err_application_not_hired: {
    message: 'Mark the candidate as hired and try again.',
  },
  err_application_not_found: {
    message: 'Application not found.',
  },
  err_kombo_employee_already_exists: {
    message: 'Employee already exists in the HRIS.',
  },
  err_kombo_permission_missing: {
    message: 'Integration is missing a required permission.',
  },
  err_kombo_file_too_large: {
    message: 'An uploaded document is too large.',
  },
  err_kombo_api_failed: {
    message: "Couldn't push to the HRIS. Please retry.",
  },
  err_kombo_unexpected: {
    message: 'Something went wrong. Please retry.',
  },
  // Darwinbox push / service errors (err_unexpected_error is shared, above).
  err_darwinbox_integration_not_found: {
    message: 'Darwinbox is not connected. Enable it in Settings and try again.',
  },
  err_darwinbox_integration_not_active: {
    message: 'Darwinbox integration is inactive. Reconnect it in Settings.',
  },
  err_darwinbox_push_failed: {
    message: "Couldn't add the candidate to Darwinbox. Please retry.",
  },
  err_darwinbox_push_missing_user_id: {
    message:
      'Darwinbox accepted the request but returned no employee ID. Retry or contact support@kula.ai.',
  },
  err_connection_timeout: {
    message: 'The request to Darwinbox timed out. Please retry.',
  },
  err_database_error: {
    message: 'Something went wrong while saving. Please retry.',
  },
  // Darwinbox connect (credential form) errors.
  err_client_id_not_present: {
    message: 'Client ID is required.',
  },
  err_client_secret_not_present: {
    message: 'Client Secret is required.',
  },
  err_subdomain_not_present: {
    message: 'Subdomain is required.',
  },
  err_darwinbox_invalid_subdomain: {
    message: 'Enter a valid subdomain, e.g. "acme".',
  },
  err_darwinbox_invalid_credentials: {
    message:
      'Darwinbox rejected the credentials. Check your Client ID, Client Secret, and Subdomain.',
  },
  err_darwinbox_verification_failed: {
    message: 'Darwinbox connection could not be verified. Please try again.',
  },
  // SpotDraft connect errors.
  err_spotdraft_credentials_missing: {
    message: 'Client ID and Client Secret are required.',
  },
  err_invalid_spotdraft_credentials: {
    message: 'SpotDraft rejected these credentials.',
  },
};

export default integrations;
